const STORAGE_KEY = 'auth.redirectAttempts';

export const MAX_AUTH_REDIRECTS = 3;

// Редиректы считаются серией, только если идут чаще этого окна: автоматический цикл
// через SSO делает оборот за секунды, а редкий одиночный редирект (протухший токен
// раз в час) серией не является и лимит не копит.
export const AUTH_REDIRECT_WINDOW_MS = 60 * 1000;

// Счётчик живёт в sessionStorage, потому что каждый редирект на SSO полностью
// перезагружает страницу — переменная в памяти цикл не заметит.
function readState() {
    try {
        const state = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
        if (!state || typeof state.n !== 'number' || typeof state.ts !== 'number') {
            return null;
        }

        return state;
    } catch (error) {
        return null;
    }
}

/**
 * Регистрирует попытку полного редиректа на SSO.
 * Возвращает false, когда за последнее окно попыток уже MAX_AUTH_REDIRECTS —
 * редиректить больше нельзя, надо показывать страницу ошибки.
 */
export function tryAuthRedirect() {
    const now = Date.now();
    const state = readState();
    const isSeries = state !== null && now - state.ts <= AUTH_REDIRECT_WINDOW_MS;
    const attempts = isSeries ? state.n : 0;

    if (attempts >= MAX_AUTH_REDIRECTS) {
        return false;
    }

    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ n: attempts + 1, ts: now }));
    } catch (error) {
        // приватный режим/запрет storage — работаем без счётчика
    }

    return true;
}

/**
 * Сбрасывает счётчик немедленно, не дожидаясь истечения окна.
 * Вызывается страницей ошибки: она останавливает автоматические редиректы,
 * поэтому ручная повторная попытка должна получить свежий лимит.
 */
export function resetAuthRedirects() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        // ignore
    }
}
